import './App.scss';
import api from "./api";
import {useState, useEffect} from "react";
import {encode as base64_encode} from 'base-64';

function App() {
  // const testGetCall = () => {
  //   console.log('GET');
  //   api.get('/', ).then((response) => {
  //     console.log(response.data);
  //   }).catch((error) => {
  //     console.log(error);
  //   });
  // }
  //
  // const testPostCall = () => {
  //   console.log('POST');
  //   api.post('user/log', {message: 'message' }).then((response) => {
  //     console.log(response.data);
  //   }).catch((error) => {
  //     console.log(error);
  //   });
  // }
  //
  // const testDB = () => {
  //   console.log('DB');
  //   api.post('user/db-test', {ain: 'IE1234', email: 'chboylan@deloitte.ie'}).then((response) => {
  //     console.log(response.data);
  //   }).catch((error) => {
  //     console.log(error);
  //   });
  // }

  const handleSamlRedirect = () => {
    console.log('SAML');

    let samlResponse = `<samlp:Response ID="_b3e5b1f1-d7bd-471d-b551-c95198ff4e42" Version="2.0" IssueInstant="2022-01-25T14:28:04.969Z" Destination="https://nest-app-5daafesqpq-ew.a.run.app/api/user/saml" xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol"><Issuer xmlns="urn:oasis:names:tc:SAML:2.0:assertion">https://sts.windows.net/2242945a-4ab9-4132-840e-cce1c66e31bb/</Issuer><samlp:Status><samlp:StatusCode Value="urn:oasis:names:tc:SAML:2.0:status:Success"/></samlp:Status><Assertion ID="_3cb9c839-d118-43d4-8a5e-c8c1f2f68f00" IssueInstant="2022-01-25T14:28:04.969Z" Version="2.0" xmlns="urn:oasis:names:tc:SAML:2.0:assertion"><Issuer>https://sts.windows.net/2242945a-4ab9-4132-840e-cce1c66e31bb/</Issuer><Signature xmlns="http://www.w3.org/2000/09/xmldsig#"><SignedInfo><CanonicalizationMethod Algorithm="http://www.w3.org/2001/10/xml-exc-c14n#"/><SignatureMethod Algorithm="http://www.w3.org/2001/04/xmldsig-more#rsa-sha256"/><Reference URI="#_3cb9c839-d118-43d4-8a5e-c8c1f2f68f00"><Transforms><Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"/><Transform Algorithm="http://www.w3.org/2001/10/xml-exc-c14n#"/></Transforms><DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"/><DigestValue>7LuuzoNPbG/R4vzB8Ba02X+B44WdfMWoWHov1RQyrGI=</DigestValue></Reference></SignedInfo><SignatureValue>Hm2B7/S8eL9lyiGb0Ub+7IZSHPabvW9tifBlGcYO0C8fnrzm3/UFMb96QOmErFNMHB9tTgR7eDONr0r65ey2b028zeg7kaMgeOmzW11nwh81SFlwOGsWVQ2BsXyDPu3wt+UOnN2UJ8kUNZeEZNgAf49zwZkjEAuVr+84jrmhNDmIqA2KdPnXY4pJBGc/r6R43DwPlV4XpbRe/lvMV0jj5XKPJvPjg2YPydNXp0/xFl38GzaHSP9JIjXZR5wxekDYck2OHlv0F4+7zaE0GdBecSLWA/5N5xAmvpisxMk9Ie6NtAYbVWEnI/SmaX7tVU6D5q41O0aqZWBkuRzVEh5fww==</SignatureValue><KeyInfo><X509Data><X509Certificate>MIIC8DCCAdigAwIBAgIQTtlzAkZtA65GPhxIlhQKMzANBgkqhkiG9w0BAQsFADA0MTIwMAYDVQQDEylNaWNyb3NvZnQgQXp1cmUgRmVkZXJhdGVkIFNTTyBDZXJ0aWZpY2F0ZTAeFw0yMTExMTcwOTIxMTlaFw0yNDExMTcwOTIxMTlaMDQxMjAwBgNVBAMTKU1pY3Jvc29mdCBBenVyZSBGZWRlcmF0ZWQgU1NPIENlcnRpZmljYXRlMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA70NaNP9rXflreI3gvDnT9ksfJCTFWvVD9LvDe1AFxvb+Zbs7lwGkyQ8ZhljCWNUaZ51hxHCXOoEevEPDwyYFItyeIIvsCf2qYSrwfvw5qCNyA290iVqZCEGxAta7wBURelpDpYDW+3JLojHYUSrLoj0gA+zCchoGlV51mx9AlOt/qa7/92Ub7u5oFtcYyGp+HWr64X2vBCYwTTPzmWDpFsTLcW1dQfcF0e1Br6INQ92G9VNIdqYpG+7pFTUqNGhMbVpjOjAjaNEEs5SCUdc739/M4v9qhzn9L0SiC3S9Sy7lU9+b7Mx9K/bt7zxi/myPxX8D/oQhKegDmmIgX0gVcQIDAQABMA0GCSqGSIb3DQEBCwUAA4IBAQBTRgS+mH7T6LupNw9HVbvKQNnB3WF2xwo1LqJSReV2GSbo4YBO9r6YQxxn/Gkp5OBVfThWWd7D5NfffFadI7z219k8wb5KbECg8S/2RdhFaC3u147qkGDvP1Wd7DJqeJoXHbI2TcQuvMVGw1AYoiSPnmB7mp9iBSinmfzn3km8O8RDPRg7PwXpHwpCDTCDH/xb7iwAlhBYeJaRiIa0kmLlFPCf5zaA88n1J4ryOLMn7z1Nq+f/PtemsxjXIkZOSONqUPZY5ANmolVD8qnfkq21mm9aSiLhHcwv8eCN61bTa39Ghg8PASmLtXn2rsC+VBf/dw4ZjFpA/CKsldGSUx56</X509Certificate></X509Data></KeyInfo></Signature><Subject><NameID Format="urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified">har02048@tjx.com</NameID><SubjectConfirmation Method="urn:oasis:names:tc:SAML:2.0:cm:bearer"><SubjectConfirmationData NotOnOrAfter="2022-01-25T15:28:04.688Z" Recipient="https://nest-app-5daafesqpq-ew.a.run.app/api/user/saml"/></SubjectConfirmation></Subject><Conditions NotBefore="2022-01-25T14:23:04.688Z" NotOnOrAfter="2022-01-25T15:28:04.688Z"><AudienceRestriction><Audience>https://tjx-goverify.my.salesforce.com</Audience></AudienceRestriction></Conditions><AttributeStatement><Attribute Name="http://schemas.microsoft.com/identity/claims/tenantid"><AttributeValue>2242945a-4ab9-4132-840e-cce1c66e31bb</AttributeValue></Attribute><Attribute Name="http://schemas.microsoft.com/identity/claims/objectidentifier"><AttributeValue>deb3cc18-3ed3-4757-9069-01ae3871a234</AttributeValue></Attribute><Attribute Name="http://schemas.microsoft.com/identity/claims/identityprovider"><AttributeValue>https://sts.windows.net/2242945a-4ab9-4132-840e-cce1c66e31bb/</AttributeValue></Attribute><Attribute Name="http://schemas.microsoft.com/claims/authnmethodsreferences"><AttributeValue>http://schemas.microsoft.com/ws/2008/06/identity/authenticationmethod/password</AttributeValue></Attribute><Attribute Name="Email address"><AttributeValue>${email}</AttributeValue></Attribute><Attribute Name="First Name"><AttributeValue>Demo</AttributeValue></Attribute><Attribute Name="Last Name"><AttributeValue>User</AttributeValue></Attribute><Attribute Name="User AIN"><AttributeValue>${userId}</AttributeValue></Attribute></AttributeStatement><AuthnStatement AuthnInstant="2022-01-25T14:27:24.610Z" SessionIndex="_3cb9c839-d118-43d4-8a5e-c8c1f2f68f00"><AuthnContext><AuthnContextClassRef>urn:oasis:names:tc:SAML:2.0:ac:classes:Password</AuthnContextClassRef></AuthnContext></AuthnStatement></Assertion></samlp:Response>`
    let encoded = base64_encode(samlResponse);

    api.post('user/demo', {SAMLResponse: encoded})
      .then((response) => {
        console.log(response.data.url);
        window.location = response.data.url;
      })
      .catch(error => {
        console.log(error);
      });
  }

  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    console.log('here');
    if (email !== '' && userId !== '') {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [email, userId]);

  return (
    <div className="gov__container">

      <div className='gov__logo'>
        <div>
          <span>GoVerify</span><span>.</span>
        </div>
      </div>

      <p>Note: Ensure the following points are fulfilled in order to see sample data returned:</p>
      <ul>
        <li>Checks must be in the state <strong>Pending Face To Face</strong> and be marked
          as <strong>current</strong> on the <strong>GV-QA</strong> Salesforce environment.
        </li>
        <li>The <strong>client data</strong> on each check must be configured to match the <strong>email</strong> and <strong>ID</strong> that is submitted when
          logging in
        </li>
      </ul>

      <div className='input'>
        <label htmlFor='email'>Email: </label>
        <input id='email' type="text" value={email} onChange={e => setEmail(e.target.value)}/>
        <br/>
        <label htmlFor='id'>User ID: </label>
        <input className='.gov__text-input' id='id' type="text" value={userId}
               onChange={e => setUserId(e.target.value)}/>
      </div>


      <br/>
      {/*<button onClick={testGetCall}>GET</button>*/}
      {/*<button onClick={testPostCall}>POST</button>*/}
      {/*<button onClick={testDB}>DB</button>*/}

      <button
        className="gov__btn"
        disabled={buttonDisabled}
        onClick={handleSamlRedirect}
        type="button"
      >
        Login
      </button>

    </div>
  );
}

export default App;
